<div class="employee-details-disciplinary-measure">
	<div class="employee-details-disciplinary-measure__header">
		<h3 class="employee-details-disciplinary-measure__title">Advertências e suspensões</h3>
		<p class="employee-details-disciplinary-measure__subtitle">
			Histórico disciplinar formalizado pelo RH.
		</p>
	</div>

	<section class="section-datatable">
		<ng-container *ngIf="statusScreen === 'fetched'; else loadingBlock">
			<div class="card card-fit card-table shadow mt-2">
				<div class="card-body card-table p-0">
					<div class="table-responsive">
						<ngx-datatable
							class="ngx-datatable-custom"
							[rows]="pagedRows"
							[rowHeight]="'auto'"
							[columnMode]="'force'"
							[headerHeight]="56"
							[footerHeight]="0"
							[externalSorting]="true"
							[sorts]="currentSort ? [currentSort] : []"
							(sort)="onSort($event)"
						>
							<ngx-datatable-column name="Data" prop="occurrenceDate" [width]="140">
								<ng-template ngx-datatable-header-template let-column="column">
									Data
								</ng-template>
								<ng-template ngx-datatable-cell-template let-row="row">
									<span>
										{{ (row.occurrenceDate || row.creationDate) | date: 'dd/MM/yyyy' }}
									</span>
								</ng-template>
							</ngx-datatable-column>

							<ngx-datatable-column name="Tipo" prop="occurrenceTypeLabel" [width]="180">
								<ng-template ngx-datatable-header-template let-column="column">
									Tipo
								</ng-template>
								<ng-template ngx-datatable-cell-template let-row="row">
									<span
										class="badge text-wrap"
										[ngClass]="getOccurrenceTypeBadgeClass(row)"
									>
										{{ row.occurrenceTypeLabel }}
									</span>
								</ng-template>
							</ngx-datatable-column>

							<ngx-datatable-column name="Motivo" prop="occurrenceJustificationLabel" [width]="260">
								<ng-template ngx-datatable-header-template let-column="column">
									Motivo
								</ng-template>
								<ng-template ngx-datatable-cell-template let-row="row">
									<span
										*ngIf="row.occurrenceJustificationLabel && row.occurrenceJustificationLabel !== '-'"
										class="badge bg-light-secondary text-wrap"
									>
										{{ row.occurrenceJustificationLabel }}
									</span>
									<span *ngIf="!row.occurrenceJustificationLabel || row.occurrenceJustificationLabel === '-'">-</span>
								</ng-template>
							</ngx-datatable-column>

							<ngx-datatable-column name="Dias" prop="amountDays" [width]="90">
								<ng-template ngx-datatable-header-template let-column="column">
									Dias
								</ng-template>
								<ng-template ngx-datatable-cell-template let-row="row">
									<span>{{ formatDays(row) }}</span>
								</ng-template>
							</ngx-datatable-column>

							<ngx-datatable-column name="Descrição" prop="note" [flexGrow]="1" [minWidth]="200">
								<ng-template ngx-datatable-header-template let-column="column">
									Descrição
								</ng-template>
								<ng-template ngx-datatable-cell-template let-row="row">
									<span
										#noteEl
										class="employee-details-disciplinary-measure__note"
										[ngbTooltip]="row.note"
										placement="left"
										container="body"
										tooltipClass="disciplinary-measure-note-tooltip"
										[disableTooltip]="!shouldShowNoteTooltip(row, noteEl)"
									>
										{{ row.note }}
									</span>
								</ng-template>
							</ngx-datatable-column>
						</ngx-datatable>
					</div>

					<div class="card-footer" *ngIf="count > 0">
						<app-paginator
							type="squared"
							class="flex-1"
							[count]="count"
							[filter]="queryParams.filter"
							[queryParams]="queryParams"
							[optionSize]="[8, 10, 30, 50]"
							[showDisplayedCount]="true"
							(query)="onPaginatorQuery()"
						>
						</app-paginator>
					</div>
				</div>
			</div>
		</ng-container>
	</section>
</div>

<ng-template #loadingBlock>
	<ng-container [ngSwitch]="statusScreen">
		<ng-container *ngSwitchCase="'loading'">
			<div class="card card-fit card-table shadow mt-2">
				<div class="card-body pt-2">
					<div class="flex flex-1 gap-2 p-1 flex-column justify-content-center align-items-center">
						<span class="spinner-border text-primary spinner-border-lg mr-1"></span>
						<span>Carregando</span>
					</div>
				</div>
			</div>
		</ng-container>

		<ng-container *ngSwitchCase="'empty'">
			<div class="card card-fit card-table shadow mt-2">
				<div class="card-body pt-2">
					<div class="flex flex-1 gap-2 p-1 flex-column justify-content-center align-items-center">
						<span>Não há registros para exibir.</span>
					</div>
				</div>
			</div>
		</ng-container>

		<ng-container *ngSwitchCase="'error'">
			<div class="card card-fit card-table shadow mt-2">
				<div class="card-body pt-2">
					<div class="flex flex-1 gap-2 p-1 flex-column justify-content-center align-items-center">
						<span>Não foi possível carregar as advertências.</span>
						<button type="button" class="btn btn-outline-primary btn-sm" (click)="retryLoad()">
							Tentar novamente
						</button>
					</div>
				</div>
			</div>
		</ng-container>
	</ng-container>
</ng-template>
